/**
 * Protected Route Component
 * Wraps routes that require authentication
 * @module components/guards/ProtectedRoute
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute - Ensures user is authenticated before rendering
 * @param {Object} props - Component props
 * @param {React.Component} props.children - Child components to render
 * @param {Object} props.user - Current user object
 * @param {string} props.fallbackPath - Path to redirect if not authenticated
 * @returns {React.Component} - Protected route or redirect
 */
const ProtectedRoute = ({ children, user, fallbackPath = '/login' }) => {
  if (!user) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
};

export default ProtectedRoute;

